import { useCallback } from 'react';
import { SegmentedVideoPlayerProps } from './types';
import { calculateDurationMillis } from './utils';

export type UseDurationProps = Pick<SegmentedVideoPlayerProps, 'segments'>;

/**
 * Calculates duration from the segments
 */
export default function useDuration(props: UseDurationProps) {
  const { segments } = props;

  const getDurationMillis = useCallback(() => {
    return calculateDurationMillis(segments);
  }, [segments]);

  return {
    getDurationMillis,
  };
}
